<template>
  <div class="step2">
    <div class="content">
      <div class="form">
        <a-form
          class="ant-advanced-search-form formBox"
          :form="form"
        >
          <a-row :gutter="24">
            <!-- <a-col v-if="productConfirm" span="24">
              <label style="color: #ed1c24;line-height: 41px;margin-bottom: 24px;display: block;">{{ $t('view-components-components/tip') }}</label>
            </a-col>
            <a-col span="24">
              <a-form-item
                :label="$t('user-comphonents-step2/years')"
                required
              >
                <a-select
                  v-model="form.market_launch"
                  :disabled="readonly"
                >
                  <a-select-option
                    v-for="i in marketLaunch"
                    :key="i.value"
                    :value="i.value"
                  >
                    {{ i.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col> -->

            <a-col span="24">
              <!-- 中文描述 -->
              <a-form-item
                :label="$t('user-productInfo-description/descriptionZh')"
                required
              >
                <div style="margin-bottom: 16px;">
                  <!-- 第一行灰色区域描述 -->
                  <font
                    size="2.5"
                    color="666666"
                  >
                    {{ $t('user-productInfo-description/tip') }}<br>
                  </font>
                </div>
                <a-input
                  v-model="form.description_cn"
                  type="textarea"
                  :disabled="readonly"
                  auto-size
                  style="height: 100px;"
                  @change="textareaChange1"
                />
                <span style="float:right;line-height: 20px;">{{ textareaLength1 }}/300</span>
              </a-form-item>
            </a-col>
            <!-- 获奖后将根据该尺寸进行作品打样，若为类别01、04，尺寸可填写为1区域 -->
            <!-- <a-col
              span="24"
              style="color: #ff0000;"
            >
              获奖后将根据该尺寸进行作品打样，若为类别01、04，尺寸可填写为1
            </a-col> -->
            <!-- <a-col
              span="12"
            >
              <a-form-item
                :label="$t('user-productInfo-logistics/hight')"
              >
                <a-input
                  v-model="form.height"
                  :disabled="readonly"
                />
              </a-form-item>
            </a-col>
            <a-col
              span="12"
            >
              <a-form-item
                :label="$t('user-productInfo-logistics/width')"
              >
                <a-input
                  v-model="form.width"
                  :disabled="readonly"
                />
              </a-form-item>
            </a-col>
            <a-col
              span="12"
            >
              <a-form-item
                :label="$t('user-productInfo-logistics/depth')"
              >
                <a-input
                  v-model="form.depth"
                  :disabled="readonly"
                />
              </a-form-item>
            </a-col> -->
            <a-col span="24">
              <!-- 上传图片 -->
              <!-- action="https://www.mocky.io/v2/5cc8019d300000980a055e76" -->
              <a-upload
                action=""
                list-type="picture-card"
                :file-list="form.thumbs"
                :before-upload="beforeUpload"
                @preview="handlePreview"
                @change="handleChange"
              >
                <div>
                  <a-button style="margin: 3px 15px 0 0;float:left;pointer-events: auto;color: #fa4646;border-color: #fa4646;" :disabled="readonly"><a-icon type="upload" /> {{ $t('view-components-components/Upload') }}</a-button>
                </div>
              </a-upload>
              <!-- <div style="margin-top: 15px;">
                <font
                  size="2.5"
                  color="red"
                  style="font-weight: bold;"
                >
                  {{ $t('user-productInfo-description/uploadTip3') }}
                </font>
                <font
                  size="2.5"
                  color="666666"
                >
                  {{ $t('user-productInfo-description/uploadTip4') }}
                </font>
              </div> -->
              <div style="margin-top: 8px;">
                <font
                  size="2.5"
                  color="666666"
                >
                  {{ $t('user-productInfo-description/uploadTip') }}
                </font>
              </div>
              <!-- <div style="margin-top: 8px;">
                <font
                  size="2.5"
                  color="666666"
                >
                  多媒体文件：将参赛作品中具有代表性的页面进行截图后提交至线上报名系统。此外多媒体文件还需以邮件形式提交到官方邮箱： zzid2020@163.com 。邮件内需备注"第六届"龙江杯"（漳州）工业设计创新大赛+作品编号"。作品时长不超过5分钟，文件大小不得超过100MB，格式为MOV或WMV或AVI/MP4或SWF或MPEG/MPG。
                </font>
              </div> -->
              <!-- PhotoSwipe 图片预览已集成到 handlePreview 方法中 -->
            </a-col>

            <!-- 视频上传区域 -->
            <a-col span="24" style="margin-top: 20px;">
              <div class="video-upload-container">
                <!-- 视频列表 -->
                <div class="video-list">
                  <div
                    v-for="(file, index) in form.videos"
                    :key="file.uid || index"
                    class="video-list-item"
                  >
                    <div class="video-item-content">
                      <div class="video-icon">
                        <a-icon type="video-camera" />
                      </div>
                      <div class="video-details">
                        <div class="video-name">{{ file.name }}</div>
                        <div v-if="file.status === 'uploading'" class="video-status">
                          <a-icon type="loading" /> 上传中...
                        </div>
                      </div>
                      <div class="video-actions">
                        <a-button
                          size="small"
                          title="预览视频"
                          type="link"
                          style="color: #1890ff; display: flex;align-items: center;justify-content: center;"
                          @click="handleVideoPreview(file)"
                        >
                          <a-icon type="eye" />
                        </a-button>
                        <a-button
                          v-if="!readonly"
                          size="small"
                          type="link"
                          title="删除视频"
                          style="color: #fa4646; display: flex;align-items: center;justify-content: center;"
                          @click="handleVideoDelete(file, index)"
                        >
                          <a-icon type="close-circle" />
                        </a-button>
                      </div>
                    </div>
                  </div>

                  <!-- 上传按钮 -->
                  <div
                    v-if="form.videos.length < 1 && !readonly"
                    class="video-upload-btn-text"
                    @click="triggerVideoUpload"
                  >
                    <a-icon type="upload" />
                    <span>{{ $t('user-productInfo-description/uploadVideo') }}</span>
                  </div>
                </div>

                <!-- 隐藏的文件输入框 -->
                <input
                  ref="videoInput"
                  type="file"
                  accept="video/*"
                  style="display: none;"
                  @change="handleVideoFileSelect"
                >
              </div>

              <div style="margin-top: 8px;">
                <font
                  size="2.5"
                  color="666666"
                >
                  {{ $t('user-productInfo-description/uploadVideoTip') }}
                </font>
              </div>

              <!-- 视频预览模态框 -->
              <a-modal
                :visible="videoPreviewVisible"
                :footer="null"
                width="800px"
                @cancel="handleVideoCancel"
              >
                <video
                  v-if="previewVideo"
                  :src="previewVideo"
                  controls
                  style="width: 100%;"
                >
                  您的浏览器不支持视频播放
                </video>
              </a-modal>
            </a-col>
            <a-col
              span="24"
            >
              <div v-if="isProductInnovation" style="margin-bottom: 20px; margin-top: 20px;">
                <a-upload
                  action=""
                  list-type="picture-card"
                  :file-list="form.market_file"
                  :before-upload="beforeUpload"
                  @preview="(file) => handlePreview(file, 'market_file')"
                  @change="handleChange2"
                >
                  <div>
                    <a-button style="margin: 3px 15px 0 0;float:left;pointer-events: auto;color: #fa4646;border-color: #fa4646;" :disabled="readonly"><a-icon type="upload" /> {{ $t('user-productInfo-logistics/materials') }}</a-button>
                  </div>
                </a-upload>
                <div><span class="red-dot" /><span>{{ $t('user-productInfo-logistics/market') }}</span></div>
              </div>
            </a-col>
            <a-col
              v-if="role === 4 || role === 5"
              span="18"
            >
              <!-- 反馈区域 -->
              <a-form-item
                label="反馈"
                style="margin-top: 20px;"
              >
                <a-input
                  v-model="form.feedback"
                  :disabled="readonly"
                  style="width: 70%;margin-right: 10px;"
                />
                <a-button
                  :disabled="readonly"
                  @click="submit"
                >
                  发送
                </a-button>
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <div v-if="showLoading" class="myLoading">
        <a-icon type="loading" />
        <span>Uploading</span>
      </div>
      <div style="width: 337px;" />
      <!-- <describe :describe="describe" /> -->
    </div>

    <!-- 图片预览组件 -->
    <PreviewImage
      v-if="previewVisible"
      :images="previewImages"
      :index="previewIndex"
      @closePreview="handleClosePreview"
    />
  </div>
</template>
<script>
import request from '@/utils/request'
import { productsUploadImage, productsSendOut, productsUploadVideo } from '@/api/product'
import PreviewImage from '@/views/components/PreviewImage.vue'

// const CounterByte = function(str) {
//   if (!str) return 0
//   var count = 0
//   for (var i = 0, l = str.length; i < l; i++) {
//     count += str.charCodeAt(i) <= 128 ? 1 : 2
//   }
//   return count
// }
function getBase64(files) {
  return new Promise((resolve, reject) => {
    if (!files.length) {
      const reader = new FileReader()
      reader.readAsDataURL(files)
      reader.onload = () => resolve(reader.result)
      reader.onerror = error => reject(error)
    } else {
      // 多图片转换
      const array = []
      const length = files.length
      for (const i in files) {
        const reader = new FileReader()
        reader.readAsDataURL(files[i])
        reader.onload = function() {
          array.push(reader.result)
          if (array.length === length) {
            resolve(array)
          }
        }
        reader.onerror = error => reject(error)
      }
    }
  })
}

export default {
  components: {
    PreviewImage
  },
  props: {
    form: {
      type: Object,
      default: () => {}
    },
    cates: {
      type: Array,
      default: () => {}
    },
    describe: {
      type: Object,
      default: () => {}
    },
    readonly: {
      type: Boolean,
      default: false
    },
    marketLaunch: {
      type: Array,
      default: () => {}
    },
    id: {
      type: Number,
      default: 0
    },
    savedImagesNum: {
      type: Number,
      default: 0
    },
    savedMarketFileNum: {
      type: Number,
      default: 0
    },
    productConfirm: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      previewImage: '',
      textareaLength1: 0,
      textareaLength2: 0,
      markUId: '',
      showLoading: false,
      request: request,
      videoPreviewVisible: false,
      previewVideo: '',
      // 预览组件相关
      previewVisible: false,
      previewImages: [],
      previewIndex: 0
    }
  },
  computed: {
    locale() {
      return this.$i18n.locale
    },
    isProductInnovation() {
      if (!this.cates.slice(1)) return false
      return this.cates.slice(1).find(a => a.value === this.$store.state.global.competitionCategory)?.name.includes('产品创新')
    },
    role() {
      return this.$store.getters.user.role
    }
  },
  watch: {
    locale(e) {
      console.log(e) // 根据e对变量重新赋值
    }
  },
  created() {
  },
  mounted() {
    // this.textareaLength1 = CounterByte(this.form.description_cn)
    // this.textareaLength2 = CounterByte(this.form.description_en)
    this.textareaLength1 = this.form.description_cn ? this.form.description_cn.length : 0

    // 为已存在的视频文件生成默认封面
    this.initExistingVideos()
  },
  beforeDestroy() {
    // 清理预览状态
    this.previewVisible = false
    this.previewImages = []
    this.previewIndex = 0
  },
  methods: {
    /**
     * 初始化已存在的视频文件
     */
    initExistingVideos() {
      if (this.form.videos && this.form.videos.length > 0) {
        this.form.videos.forEach(video => {
          if (video.url && !video.thumbnail) {
            // 为已存在的视频生成默认封面
            video.thumbnail = this.getDefaultVideoThumbnail()
          }
          // 参考图片上传，为已存在的视频设置状态
          if (video.url) {
            video.status = 'success'
            video.isSaved = true
          }
        })
      }
    },
    handleCancel() {
      this.previewVisible = false
    },
    /**
     * 处理图片预览
     * @param {Object} file 要预览的文件对象
     * @param {string} sourceType 来源类型：'thumbs' 或 'market_file'
     */
    async handlePreview(file, sourceType = 'thumbs') {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj)
      }

      // 根据来源类型选择对应的图片列表
      const sourceList = sourceType === 'market_file' ? this.form.market_file : this.form.thumbs

      // 准备预览图片列表
      this.previewImages = sourceList.map(item => {
        const imageUrl = (item.url || item.preview || '').replace('-thumb', '')
        return imageUrl
      }).filter(url => url) // 过滤掉空URL

      // 找到当前图片的索引
      const currentImageUrl = (file.url || file.preview || '').replace('-thumb', '')
      this.previewIndex = this.previewImages.findIndex(url => url === currentImageUrl)

      // 如果找不到当前图片，默认显示第一张
      if (this.previewIndex === -1) {
        this.previewIndex = 0
      }

      // 显示预览组件
      this.previewVisible = true
    },

    /**
     * 关闭预览
     */
    handleClosePreview() {
      this.previewVisible = false
      this.previewImages = []
      this.previewIndex = 0
    },
    handleChange({ fileList }) {
      // 长度变短表示删除
      if (this.readonly) return
      if (fileList.length < this.form.thumbs.length) {
        const that = this
        this.$confirm({
          content: this.$t('view-components-components/deleteConfirm'),
          okText: this.$t('view-components-components/confirm'),
          cancelText: this.$t('admin-profile-edit/cancel'),
          onOk() {
            that.form.thumbs = fileList
            that.saveImages(true)
          },
          onCancel() {
          }
        })

        return
      }
      this.form.thumbs = fileList
      // 图片不单独上传，未配服务器地址时图片会出现红框
      for (const i in this.form.thumbs) {
        this.form.thumbs[i].status = 'success'
      }
      const file = fileList[fileList.length - 1]

      if (file.uid === this.markUId) {
        // 检查是否选择了类别
        if (!this.describe.pi_code && !this.$store.state.global.competitionCategory) {
          this.$message.warning({ content: '请先完善作品信息', key: 'message', duration: 4 })
          this.form.thumbs.splice(this.form.thumbs.length - 1, 1)
          return
        }

        if (file.size / 1024 / 1024 > 10) {
          this.$message.error({ content: this.$t('view-components-components/big'), key: 'message', duration: 4 })
          this.form.thumbs.splice(this.form.thumbs.length - 1, 1)
          return
        }
        if (this.form.thumbs.length > 5) {
          this.$message.error({ content: this.$t('view-components-components/big2'), key: 'message', duration: 4 })
          this.form.thumbs.splice(this.form.thumbs.length - 1, 1)
          return
        }
        if (file.type !== 'image/jpeg' && file.type !== 'image/png') {
          this.$message.error({ content: this.$t('view-components-components/product'), key: 'message' })
          this.form.thumbs.splice(this.form.thumbs.length - 1, 1)
          return
        }
      }
      if (file.percent === 0) {
        this.saveImages()
      }
    },
    handleChange2({ fileList }) {
      // 长度变短表示删除
      if (this.readonly) return
      if (fileList.length < this.form.market_file.length) {
        const that = this
        this.$confirm({
          content: this.$t('view-components-components/deleteConfirm'),
          okText: this.$t('view-components-components/confirm'),
          cancelText: this.$t('admin-profile-edit/cancel'),
          onOk() {
            that.form.market_file = fileList
            that.saveMaketFile(true, 4)
          },
          onCancel() {
          }
        })

        return
      }
      this.form.market_file = fileList
      // 图片不单独上传，未配服务器地址时图片会出现红框
      for (const i in this.form.market_file) {
        this.form.market_file[i].status = 'success'
      }
      const file = fileList[fileList.length - 1]

      if (file.uid === this.markUId) {
        // 检查是否选择了类别
        if (!this.describe.pi_code && !this.$store.state.global.competitionCategory) {
          this.$message.warning({ content: '请先完善作品信息', key: 'message', duration: 4 })
          this.form.market_file.splice(this.form.market_file.length - 1, 1)
          return
        }

        if (file.size / 1024 / 1024 > 10) {
          this.$message.error({ content: this.$t('view-components-components/big'), key: 'message', duration: 4 })
          this.form.market_file.splice(this.form.market_file.length - 1, 1)
          return
        }
        if (this.form.market_file.length > 5) {
          this.$message.error({ content: this.$t('view-components-components/big2'), key: 'message', duration: 4 })
          this.form.market_file.splice(this.form.market_file.length - 1, 1)
          return
        }
        if (file.type !== 'image/jpeg' && file.type !== 'image/png') {
          this.$message.error({ content: this.$t('view-components-components/product'), key: 'message' })
          this.form.market_file.splice(this.form.market_file.length - 1, 1)
          return
        }
      }
      if (file.percent === 0) {
        this.saveMaketFile(false, 4)
      }
    },
    beforeUpload(e) {
      this.markUId = e.uid
    },
    async saveImages(delBool, type) {
      // e.preventDefault()
      // e.stopPropagation()
      let currentId = this.id
      if (!this.describe.pi_code) {
        // 再次检查是否选择了类别
        if (!this.$store.state.global.competitionCategory) {
          this.$message.warning({ content: '请先完善作品信息', key: 'message', duration: 4 })
          return
        }
        await this.$emit('save')
        // 等待父组件的异步保存操作完成
        await new Promise(resolve => setTimeout(resolve, 500))
        // 重新获取最新的id
        currentId = this.id
      }
      const data = {
        thumbs: this.form.thumbs
      }
      const that = this

      const imgsList = []
      data.old_images = []
      for (const i in data.thumbs) {
        if (data.thumbs[i].url) {
          data.old_images.push(data.thumbs[i].url.replace('-thumb', ''))
        } else {
          imgsList.push(data.thumbs[i].originFileObj)
        }
      }
      data.thumbs = imgsList.length ? await getBase64(imgsList) : []
      this.showLoading = true

      data.images = data.thumbs
      const _thumbs = data.thumbs
      delete data.thumbs
      if (type) {
        data.type = type
      }
      productsUploadImage(currentId, data).then(res => {
        data.thumbs = _thumbs

        this.$emit('setSavedImagesNum', data.thumbs.length + data.old_images.length)
        for (const i in that.form.thumbs) {
          that.form.thumbs[i].isSaved = true
        }
        this.showLoading = false
        if (!delBool) this.$message.success({ content: this.$t('view-components-components/uploadSuccess'), key: 'message', duration: 4 })
        if (imgsList.length) this.form.thumbs[this.form.thumbs.length - 1].url = res.image_url
      }).catch(e => {
        this.showLoading = false
        this.$message.error({ content: this.$t('view-components-components/uploadFail'), key: 'message', duration: 4 })
        this.form.thumbs.splice(this.form.thumbs.length - 1, 1)
      })
    },
    async saveMaketFile(delBool, type) {
      // e.preventDefault()
      // e.stopPropagation()
      let currentId = this.id
      if (!this.describe.pi_code) {
        // 再次检查是否选择了类别
        if (!this.$store.state.global.competitionCategory) {
          this.$message.warning({ content: '请先完善作品信息', key: 'message', duration: 4 })
          return
        }
        await this.$emit('save')
        // 等待父组件的异步保存操作完成
        await new Promise(resolve => setTimeout(resolve, 500))
        // 重新获取最新的id
        currentId = this.id
      }
      const data = {
        thumbs: this.form.market_file
      }
      const that = this

      const imgsList = []
      data.old_images = []
      for (const i in data.thumbs) {
        if (data.thumbs[i].url) {
          data.old_images.push(data.thumbs[i].url.replace('-thumb', ''))
        } else {
          imgsList.push(data.thumbs[i].originFileObj)
        }
      }
      data.thumbs = imgsList.length ? await getBase64(imgsList) : []
      this.showLoading = true

      data.images = data.thumbs
      const _thumbs = data.thumbs
      delete data.thumbs
      if (type) {
        data.type = type
      }
      productsUploadImage(currentId, data).then(res => {
        data.thumbs = _thumbs

        this.$emit('setSavedMarketFileNum', data.thumbs.length + data.old_images.length)
        for (const i in that.form.market_file) {
          that.form.market_file[i].isSaved = true
        }
        this.showLoading = false
        if (!delBool) this.$message.success({ content: this.$t('view-components-components/uploadSuccess'), key: 'message', duration: 4 })
        if (imgsList.length) this.form.market_file[this.form.market_file.length - 1].url = res.image_url
      }).catch(e => {
        this.showLoading = false
        this.$message.error({ content: this.$t('view-components-components/uploadFail'), key: 'message', duration: 4 })
        this.form.market_file.splice(this.form.market_file.length - 1, 1)
      })
    },
    textareaChange1(e) {
      // this.textareaLength1 = CounterByte(e.target.value)
      this.textareaLength1 = e.target.value.trim().length
    },
    textareaChange2(e) {
      // this.textareaLength2 = CounterByte(e.target.value)
      this.textareaLength2 = e.target.value.trim().length
    },

    submit() {
      const data = {
        feedback: this.form.feedback
      }
      productsSendOut(this.id, data).then(res => {
        this.$message.success({ content: '发送成功', key: 'message', duration: 4 })
      })
    },
    /**
     * 触发视频文件选择
     */
    triggerVideoUpload() {
      this.$refs.videoInput.click()
    },

    /**
     * 处理视频文件选择
     * @param {Event} event 文件选择事件
     */
    async handleVideoFileSelect(event) {
      const file = event.target.files[0]
      if (!file) return

      // 检查是否选择了类别
      if (!this.describe.pi_code && !this.$store.state.global.competitionCategory) {
        this.$message.warning({ content: '请先完善作品信息', key: 'message', duration: 4 })
        return
      }

      // 验证文件大小
      if (file.size / 1024 / 1024 > 100) {
        this.$message.error({ content: '视频文件大小不能超过100MB', key: 'message', duration: 4 })
        return
      }

      // 验证文件格式
      const allowedTypes = ['video/mp4', 'video/avi', 'video/mov', 'video/wmv', 'video/mpeg', 'video/mpg']
      if (!allowedTypes.includes(file.type)) {
        this.$message.error({ content: '视频格式不支持，请上传MOV、WMV、AVI、MP4、SWF或MPEG/MPG格式', key: 'message', duration: 4 })
        return
      }

      // 生成唯一ID
      const uid = Date.now() + Math.random()

      // 创建文件对象
      const videoFile = {
        uid,
        name: file.name,
        size: file.size,
        type: file.type,
        originFileObj: file,
        status: 'uploading',
        percent: 0
      }

      // 提取视频第一帧作为封面
      try {
        const thumbnail = await this.extractVideoThumbnail(file)
        videoFile.thumbnail = thumbnail
      } catch (error) {
        console.error('提取视频封面失败:', error)
        // 使用默认封面
        videoFile.thumbnail = this.getDefaultVideoThumbnail()
      }

      // 添加到视频列表
      this.form.videos = [videoFile]

      // 参考图片上传流程，当percent为0时上传视频
      if (videoFile.percent === 0) {
        this.saveVideos()
      }

      // 清空文件输入框
      event.target.value = ''
    },

    /**
     * 提取视频第一帧作为封面
     * @param {File} videoFile 视频文件
     * @returns {Promise<string>} 返回base64格式的图片
     */
    extractVideoThumbnail(videoFile) {
      return new Promise((resolve, reject) => {
        const video = document.createElement('video')
        const canvas = document.createElement('canvas')
        const ctx = canvas.getContext('2d')

        video.onloadedmetadata = () => {
          // 设置canvas尺寸
          canvas.width = video.videoWidth
          canvas.height = video.videoHeight

          // 跳转到第一帧
          video.currentTime = 0
        }

        video.onseeked = () => {
          try {
            // 绘制视频第一帧到canvas
            ctx.drawImage(video, 0, 0, canvas.width, canvas.height)
            // 转换为base64
            const thumbnail = canvas.toDataURL('image/jpeg', 0.8)
            resolve(thumbnail)
          } catch (error) {
            reject(error)
          }
        }

        video.onerror = () => {
          reject(new Error('视频加载失败'))
        }

        // 创建视频URL
        const videoURL = URL.createObjectURL(videoFile)
        video.src = videoURL

        // 清理URL对象
        video.onloadeddata = () => {
          URL.revokeObjectURL(videoURL)
        }
      })
    },

    /**
     * 获取默认视频封面
     * @returns {string} 默认封面图片的base64
     */
    getDefaultVideoThumbnail() {
      // 返回一个简单的默认视频封面SVG
      return 'data:image/svg+xml;base64,' + btoa(`
        <svg width="200" height="150" xmlns="http://www.w3.org/2000/svg">
          <rect width="200" height="150" fill="#f0f0f0"/>
          <circle cx="100" cy="75" r="25" fill="#d9d9d9"/>
          <polygon points="90,65 90,85 110,75" fill="#999"/>
          <text x="100" y="120" text-anchor="middle" font-size="12" fill="#666">视频文件</text>
        </svg>
      `)
    },

    /**
     * 删除视频文件
     * @param {Object} file 视频文件对象
     * @param {number} index 文件索引
     */
    handleVideoDelete(file, index) {
      const that = this
      this.$confirm({
        title: '确认删除',
        content: `确定要删除视频文件 "${file.name}" 吗？`,
        okText: this.$t('view-components-components/confirm'),
        cancelText: this.$t('admin-profile-edit/cancel'),
        okType: 'danger',
        onOk() {
          that.form.videos.splice(index, 1)
          that.saveVideos(true)
        },
        onCancel() {
        }
      })
    },
    async saveVideos(delBool) {
      // 参考图片上传流程，先保存基本信息
      let currentId = this.id
      console.log('this.describe', this.describe)
      if (!this.describe.pi_code) {
        // 再次检查是否选择了类别
        if (!this.$store.state.global.competitionCategory) {
          this.$message.warning({ content: '请先完善作品信息', key: 'message', duration: 4 })
          return
        }
        await this.$emit('save')
        // 等待父组件的异步保存操作完成
        await new Promise(resolve => setTimeout(resolve, 500))
        // 重新获取最新的id
        currentId = this.id
      }

      const data = {
        videos: this.form.videos
      }
      const that = this

      const videosList = []
      data.old_videos = []
      for (const i in data.videos) {
        if (data.videos[i].url) {
          data.old_videos.push(data.videos[i].url)
        } else {
          videosList.push(data.videos[i].originFileObj)
        }
      }
      data.videos = videosList.length ? await getBase64(videosList) : []
      this.showLoading = true

      productsUploadVideo(currentId, data).then(res => {
        this.$emit('setSavedVideosNum', data.videos.length + data.old_videos.length)
        for (const i in that.form.videos) {
          that.form.videos[i].isSaved = true
          that.form.videos[i].status = 'success'
        }
        this.showLoading = false
        if (!delBool) this.$message.success({ content: '视频上传成功', key: 'message', duration: 4 })
        if (videosList.length) this.form.videos[this.form.videos.length - 1].url = res.video_url
      }).catch(e => {
        this.showLoading = false
        this.$message.error({ content: '视频上传失败', key: 'message', duration: 4 })
        this.form.videos.splice(this.form.videos.length - 1, 1)
      })
    },
    async handleVideoPreview(file) {
      this.videoPreviewVisible = true
      this.previewVideo = file.url || file.preview
    },
    handleVideoCancel() {
      this.videoPreviewVisible = false
      this.previewVideo = ''
    }
  }
}
</script>
<style scoped>
.content {
  display: flex;
}

.form {
  flex: 1;
  padding-bottom: 90px;
}

.formBox {
  margin-right: 54px;
}

.myLoading {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  text-align: center;
  z-index: 9999;
  padding-top: 40vh;
  box-sizing: border-box;
  font-size: 99px;
}

.myLoading i{
  color: #999999;
}

.myLoading span{
  font-size: 16px;
  position: absolute;
  left: calc(50vw - 34px);
  top: calc(40vh + 55px);
}
</style>
<style>
/* 重写上传组件 */
.ant-upload-list.ant-upload-list-picture-card::after {
  content: '';
  display: block;
  clear: both;
}

.ant-upload.ant-upload-select-picture-card {
  height: auto;
  width: auto;
  border: 0;
  background: transparent;
  margin-bottom: 0;
}

.red-dot::before {
  display: inline-block;
    margin-right: 4px;
    color: #f5222d;
    font-size: 14px;
    font-family: SimSun, sans-serif;
    line-height: 1;
    content: '*';
}

.ant-upload.ant-upload-select-picture-card > .ant-upload {
  padding: 0;
  vertical-align: bottom;
  text-align: left;
}

.step2 .anticon-eye-o {
  font-size: 24px !important;
}

.step2 textarea.ant-input{
  overflow: hidden !important;
}

/* 视频上传组件样式 - 文字列表 */
.video-upload-container {
  margin-bottom: 16px;
}

.video-list {
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  background: #fff;
  overflow: hidden;
}

.video-list-item {
  border-bottom: 1px solid #f0f0f0;
  transition: background-color 0.3s;
}

.video-list-item:last-child {
  border-bottom: none;
}

.video-list-item:hover {
  background-color: #fafafa;
}

.video-item-content {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  gap: 12px;
}

.video-icon {
  font-size: 20px;
  color: #1890ff;
  flex-shrink: 0;
}

.video-details {
  flex: 1;
  min-width: 0;
}

.video-name {
  font-size: 14px;
  color: #333;
  margin-bottom: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.video-status {
  font-size: 12px;
  color: #666;
  display: flex;
  align-items: center;
  gap: 4px;
}

.video-actions {
  display: flex;
  gap: 8px;
  flex-shrink: 0;
}

.video-actions .ant-btn-link {
  padding: 4px 8px;
  border-radius: 4px;
  transition: all 0.3s ease;
}

.video-actions .ant-btn-link:hover {
  background-color: rgba(0, 0, 0, 0.04);
  transform: scale(1.05);
}

.video-actions .ant-btn-link[style*="color: #1890ff"]:hover {
  color: #40a9ff !important;
  background-color: rgba(24, 144, 255, 0.1);
}

.video-actions .ant-btn-link[style*="color: #ff4d4f"] {
  color: #ff4d4f !important;
}

/* 确保删除按钮的图标也是红色 */
.video-actions .ant-btn-link[style*="color: #ff4d4f"] .anticon {
  color: #ff4d4f !important;
}

.video-actions .ant-btn-link[style*="color: #ff4d4f"]:hover {
  color: #ff7875 !important;
  background-color: rgba(255, 77, 79, 0.1);
}

.video-upload-btn-text {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 16px;
  color: #1890ff;
  cursor: pointer;
  transition: all 0.3s;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  background: #fafafa;
}

.video-upload-btn-text:hover {
  border-color: #1890ff;
  background: #f0f8ff;
  color: #40a9ff;
}

.video-upload-btn-text .anticon {
  font-size: 16px;
}

.video-upload-btn-text span {
  font-size: 14px;
}
</style>
